export default "__VITE_ASSET__CM_8w22c__"